import {isNil, isNotNil} from 'ramda';

import {CarStatusFilter} from '../types/CarStatusFilter';

/** Remove retired statuses from persisted filters without mapping them to another status. */
export function readCarStatusFilter(filters: object) {
  const stored = 'carStatus' in filters ? filters.carStatus : undefined;
  if (isNil(stored)) {
    return {carStatus: undefined, hasUnsupportedValues: false};
  }
  if (!Array.isArray(stored)) {
    return {carStatus: undefined, hasUnsupportedValues: true};
  }

  const carStatus: CarStatusFilter[] = [];
  let hasUnsupportedValues = false;
  for (const value of stored) {
    const supported = Object.values(CarStatusFilter).find((status) => status === value);
    if (isNotNil(supported)) {
      carStatus.push(supported);
    } else {
      hasUnsupportedValues = true;
    }
  }
  return {
    carStatus: carStatus.length > 0 ? carStatus : undefined,
    hasUnsupportedValues,
  };
}
